import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { TextField, ChipSelect, Section } from "../../../../components/common/formkit/fields";
import { FormSync, FocusFirstError } from "../../../../components/common/formkit/formHelpers";

export const amenitiesList = [
  "swimming_pool",
  "gas_connection",
  "ro",
  "club_house",
  "basketball_court",
  "tennis_court",
  "gym",
  "indoor_games",
  "child_play_area",
  "hospital_near_by",
  "mall_near_by",
  "market_near_by",
  "school_near_by",
];

export const amenitiesLabels = {
  swimming_pool: "Swimming Pool",
  gas_connection: "Gas Connection",
  ro: "RO",
  club_house: "Club House",
  basketball_court: "Basketball Court",
  tennis_court: "Tennis Court",
  gym: "Gym",
  indoor_games: "Indoor Games",
  child_play_area: "Child Play Area",
  hospital_near_by: "Hospital Near By",
  mall_near_by: "Mall Near By",
  market_near_by: "Market Near By",
  school_near_by: "School Near By",
};

// Splits the flat step values into the { structure, feature } shape the payload uses
const toFormPatch = (values, form) => {
  const feature = amenitiesList.reduce((acc, key) => {
    acc[key] = Boolean(values[key]);
    return acc;
  }, {});
  const { bedrooms, bathrooms, rooms, ...rest } = values;
  amenitiesList.forEach((key) => delete rest[key]);
  return {
    ...rest,
    feature,
    structure: {
      id: form?.structure?.id || null,
      bed_rooms: Number(bedrooms || 0),
      bath_rooms: Number(bathrooms || 0),
      rooms: Number(rooms || 0),
    },
  };
};

const Step4Features = ({ form, setForm, nextStep, formId }) => {
  const initialValues = {
    bedrooms: form?.structure?.bed_rooms || "",
    bathrooms: form?.structure?.bath_rooms || "",
    rooms: form?.structure?.rooms || "",
    tags: form?.tags || "",
    pin_code: form?.pin_code || "",
    address: form?.address || "",
    ...amenitiesList.reduce((acc, key) => {
      acc[key] = form?.feature?.[key] || false;
      return acc;
    }, {}),
  };

  const validationSchema = Yup.object({
    bedrooms: Yup.number().nullable(),
    bathrooms: Yup.number().nullable(),
    rooms: Yup.number().nullable(),
  });

  const handleSubmit = (values, { setSubmitting }) => {
    setForm((prev) => ({ ...prev, ...toFormPatch(values, prev) }));
    setSubmitting(false);
    if (nextStep) nextStep();
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ values, setFieldValue }) => (
        <Form id={formId} noValidate>
          <FormSync onChange={(v) => setForm((prev) => ({ ...prev, ...toFormPatch(v, prev) }))} />
          <FocusFirstError />

          <Section title="Internal structure" hint="All optional.">
            <div className="fk-grid fk-grid--3">
              <TextField name="bedrooms" label="Bedrooms" type="number" min="0" placeholder="Enter bedrooms" />
              <TextField name="bathrooms" label="Bathrooms" type="number" min="0" placeholder="Enter bathrooms" />
              <TextField name="rooms" label="Rooms" type="number" min="0" placeholder="Enter rooms" />
            </div>
          </Section>

          <Section title="Address & tags">
            <div className="fk-grid fk-grid--3">
              <TextField name="address" label="Address" placeholder="Enter address" />
              <TextField name="pin_code" label="Pin code" inputMode="numeric" maxLength={6} placeholder="Enter pin code" />
              <TextField name="tags" label="Tags" placeholder="Enter tags" />
            </div>
          </Section>

          <Section title="Amenities" hint="Tap to select everything that applies.">
            <ChipSelect
              ariaLabel="Amenities"
              options={amenitiesList.map((key) => ({ value: key, label: amenitiesLabels[key] }))}
              selected={amenitiesList.filter((key) => values[key])}
              onToggle={(key) => setFieldValue(key, !values[key])}
            />
          </Section>
        </Form>
      )}
    </Formik>
  );
};

export default Step4Features;
